import React from 'react';
import { HiCheck } from "react-icons/hi";
import Link from "next/link";
import WebsiteLayout from "../components/website/Layout";
import Head from "next/head";
import plans from '../plans'
import PlanFeature from '../components/website/pricing/PlanFeature'
import PlanDetails from '../components/website/pricing/PlanDetails'
import PlanFeaturesSection from '../components/website/pricing/PlanFeaturesSection'
import PlanPriceSection from '../components/website/pricing/PlanPriceSection'
import { useRouter } from 'next/router'

function Pricing() {
  const { small, basic, advanced, advancedOnSale, unlimited } = plans
  const router = useRouter()

  return (
    <>
      <Head>
        <title>זמן טוב - מחירים וחבילות</title>
        <meta property="og:title" content="זמן טוב - מחירים וחבילות" />
        <meta property="og:description" key='ogdescription'
          content="האפליקציה המתקדמת ביותר לניהול תורים למספרות, קוסמטיקאיות, מאמני כושר ועוד. הרשמו עכשיו!" />
        <meta property="og:url" key='ogurl' content={`https://zmantov.co.il/`} />
        <meta property="og:image" key='ogimage' content={'https://zmantov.co.il/img/cover-image.png'} />
      </Head>

      <div className="w-full md:mx-auto pb-20">
        <div className="pt-10 w-full px-3 mt-5 pb-20" id='pricing'>
          <h1 className="text-center text-gray-700 font-bold text-4xl sm:text-4xl w-full px-2">מחירים
            וחבילות</h1>
          <p className="text-gray-500 font-secondary pt-4 max-w-lg mx-auto text-center">הצטרפו עוד היום למערכת המהפכנית והמתקדמת ביותר בארץ לניהול תורים ולקוחות, כי הזמן והשקט שלכם שווים הרבהההה יותר!
          </p>

          <p className="text-gray-500 font-secondary pt-4 max-w-lg mx-auto text-center">כמו כן, התשלום החודשי עבור המערכת הינו הוצאה מוכרת שתוכלו לקזז למול הרווח! דברו עם רואה החשבון שלכם :)
          </p>
          <Link href={router.query?.sourceCampaign ? `/app/signup?sourceCampaign=${router.query?.sourceCampaign}` : '/app/signup'}>
            <button
              className="mx-auto mt-8 block	bg-green-500 text-lg px-6 py-3 border border-green-500 hover:bg-green-600 text-white transition duration-500 font-semibold ease-in-out hover:rounded rounded-lg">
              התנסו עם 30 ימי ניסיון
            </button>
          </Link>
          <div className="px-2 sm:px-4 mt-6 lg:px-8 mx-auto text-gray-900 w-full max-w-7xl px-5 py-12 mx-auto lg:px-20 space-y-6">
            {/*free*/}
            {/* <div className="flex flex-wrap items-center justify-start w-full bg-white border rounded-lg shadow-md group">
            <div className="w-full xl:w-1/4 md:w-1/4 md:pl-6">
              <div className="relative flex flex-col h-full py-5 md:py-8 px-4 bg-gray-50 rounded-lg md:bg-white md:border-l text-center">
                <h2
                  className="mb-2 text-2xl md:2text-xl font-bold text-green-500 tracking-tight ">
                  החינמית
                </h2>
                <p
                  className="mb-2 text-base font-normal text-gray-500 text-sm tracking-tight">
                  לעסקים קטנטנים ❤️
                </p>
              </div>
            </div>
            <div className="w-full xl:w-1/4 md:w-1/4">
              <div className="relative flex flex-col h-full py-8 px-2">
                <p
                  className="flex items-center mb-2 text-lg  text-indigo-800 justify-center md:justify-start">
                  <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                  <span className="text-gray-900 text-sm pr-1">עד <strong>10 תורים</strong> בחודש</span>
                </p>
                <p
                  className="flex items-center mb-2 text-lg  text-indigo-800 justify-center md:justify-start">
                  <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                  <span className="text-gray-900 text-sm pr-1">עד <strong> 10 לקוחות</strong> רשומים</span>
                </p>
                <p
                  className="flex items-center mb-2 text-lg font-normal text-indigo-800 justify-center md:justify-start">
                  <div className=" flex">
                    <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                    <div className='flex  flex-col text-right  pr-1'>
                      <span className="text-gray-900 text-sm"><strong>50</strong> הודעות סמס/וואטסאפ מתחדשות בחינם</span>
                    </div>
                  </div>
                </p>
              </div>
            </div>
            <div className="w-full xl:w-1/4 md:w-1/4">
              <div className="relative flex flex-col h-full md:py-8 px-2 ">
                <p
                  className="flex items-center mb-2 text-lg  text-indigo-800 justify-center md:justify-start">
                  <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                  <span className="text-gray-900 text-sm pr-1">תזכורות אוטומטיות ואישורי הגעה</span>
                </p>
                <p
                  className="flex items-center mb-2 text-lg  text-indigo-800 justify-center md:justify-start">
                  <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                  <span className="text-gray-900 text-sm pr-1">סטטיסטיקות ודוחות</span>
                </p>
                <p
                  className="flex items-center mb-2 text-lg  text-indigo-800 justify-center md:justify-start">
                  <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500"/>
                  <span className="text-gray-900 text-sm pr-1">שירות לקוחות בצ׳אט</span>
                </p>
              </div>
            </div>
            <div className="w-full xl:w-1/4 md:w-1/4 mr-auto">
              <div className="relative flex flex-col h-full p-8">
                <h1 className="flex items-end mx-auto font-semibold text-xl lg:text-2xl text-gray-900 tracking-tight">
                  ₪0 <span className='text-base text-gray-600 font-normal pr-1'>/ לחודש</span>
                </h1>
                <Link href='/app/signup'>
                  <a
                    className="px-4 py-2 text-base mt-3 sm:text-lg text-center font-primary font-medium text-white bg-green-500 rounded-full focus:outline-none hover:bg-green-600 w-full">להרשמה</a>
                </Link>
                <p className="mx-auto text-gray-600 mt-3 text-sm text-center">תוכלו לשדרג בכל זמן :)</p>
              </div>
            </div>
          </div> */}

            {/*small*/}
            <PlanDetails plan={small}>
              <>
                <PlanFeaturesSection>
                  <PlanFeature>עד <strong>{`${small.appointments} תורים`}</strong> בחודש</PlanFeature>
                  <PlanFeature>עד <strong>{`${small.customers} לקוחות`}</strong> רשומים</PlanFeature>
                  <div className="flex items-center mb-2 text-lg font-normal text-indigo-800 justify-center md:justify-start">
                    <div className="flex">
                      <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500" />
                      <div className='flex flex-col text-center md:text-right pr-1'>
                        <span className="text-gray-900 text-sm"><strong>{small.smsCredits}</strong> הודעות מתחדשות בחינם</span>
                        <span className='text-xs text-gray-600'>{`(${small.extraSMS} ש״ח לכל הודעה נוספת)`}</span>
                      </div>
                    </div>
                  </div>
                  <PlanFeature>איש צוות <strong>אחד </strong></PlanFeature>
                </PlanFeaturesSection>
                <PlanFeaturesSection>
                  <PlanFeature>תזכורות אוטומטיות ואישורי הגעה</PlanFeature>
                  <PlanFeature>סטטיסטיקות ודוחות</PlanFeature>
                  <PlanFeature>שירות לקוחות בצ׳אט</PlanFeature>
                  <PlanFeature>שליחת הודעות תפוצה</PlanFeature>
                </PlanFeaturesSection>
                <PlanPriceSection plan={small} />
              </>
            </PlanDetails>

            {/*basic*/}
            <PlanDetails plan={basic}>
              <>
                <PlanFeaturesSection>
                  <PlanFeature>עד <strong>{`${basic.appointments} תורים`}</strong> בחודש</PlanFeature>
                  <PlanFeature><strong>ללא</strong> הגבלת לקוחות רשומים</PlanFeature>
                  <div className="flex items-center mb-2 text-lg font-normal text-indigo-800 justify-center md:justify-start">
                    <div className="flex">
                      <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500" />
                      <div className='flex flex-col text-center md:text-right pr-1'>
                        <span className="text-gray-900 text-sm"><strong>{basic.smsCredits}</strong> הודעות מתחדשות בחינם </span>
                        <span className='text-xs text-gray-600'>{`(${basic.extraSMS} ש״ח לכל הודעה נוספת)`}</span>
                      </div>
                    </div>
                  </div>
                  <PlanFeature><strong>אנשי צוות ללא הגבלה</strong></PlanFeature>
                </PlanFeaturesSection>
                <PlanFeaturesSection>
                  <PlanFeature>תזכורות אוטומטיות ואישורי הגעה</PlanFeature>
                  <PlanFeature>סטטיסטיקות ודוחות</PlanFeature>
                  <PlanFeature>שירות לקוחות בצ׳אט</PlanFeature>
                  <PlanFeature>שליחת הודעות תפוצה</PlanFeature>
                </PlanFeaturesSection>
                <PlanPriceSection plan={basic} />
              </>
            </PlanDetails>

            {/*advanced*/}
            <div className="flex flex-wrap items-center justify-start w-full bg-white border rounded-lg shadow-md group">
              <div className="w-full xl:w-1/4 md:w-1/4 md:pl-6">
                <div className="relative flex flex-col h-full py-5 md:py-8 px-4 bg-gray-50 rounded-lg md:bg-white md:border-l text-center">
                  <h2
                    className="mb-2 text-2xl md:2text-xl font-bold text-green-500 tracking-tight">
                    המתקדמת
                  </h2>
                  <p
                    className="mb-2 text-base font-normal text-gray-500 text-sm tracking-tight">
                    לעסקים מתקדמים 💪
                  </p>
                  {/* <div style={{ backgroundColor: '#fde68a' }}
                    className='font-bold mx-auto max-w-52 px-2 py-1 rounded self-center text-gray-800 shadow-lg text-center md:hidden'>
                    מבצע מטורף 40% הנחה
                  </div> */}
                </div>
              </div>
              <PlanFeaturesSection>
                <PlanFeature>עד <strong>{`${advanced.appointments} תורים`}</strong> בחודש</PlanFeature>
                <PlanFeature><strong>ללא</strong> הגבלת לקוחות רשומים</PlanFeature>
                <div className="flex items-center mb-2 text-lg font-normal text-indigo-800 justify-center md:justify-start">
                  <div className="flex">
                    <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500" />
                    <div className='flex flex-col text-center md:text-right pr-1'>
                      <span className="text-gray-900 text-sm"><strong>{advanced.smsCredits}</strong> הודעות מתחדשות בחינם </span>
                      <span className='text-xs text-gray-600'>{`(${advanced.extraSMS} ש״ח לכל הודעה נוספת)`}</span>
                    </div>
                  </div>
                </div>
                <PlanFeature><strong>אנשי צוות ללא הגבלה</strong></PlanFeature>
                <PlanFeature><strong>שיוך שירותים לאנשי צוות</strong></PlanFeature>
              </PlanFeaturesSection>
              <PlanFeaturesSection>
                <PlanFeature>תזכורות אוטומטיות ואישורי הגעה</PlanFeature>
                <PlanFeature>סטטיסטיקות ודוחות</PlanFeature>
                <PlanFeature>שירות לקוחות בצ׳אט</PlanFeature>
                <PlanFeature>שליחת הודעות תפוצה</PlanFeature>
                <PlanFeature><strong>מערכת שיעורים למספר משתתפים</strong></PlanFeature>
              </PlanFeaturesSection>
              <div className="w-full xl:w-1/4 md:w-1/4 mr-auto">
                <div className="relative flex flex-col h-full p-8">
                  <h1 className="flex items-end mx-auto font-semibold text-xl lg:text-2xl text-gray-900 tracking-tight">
                    {`₪${advanced.price}`}<span className='text-base text-gray-600 font-normal pr-1'>/ לחודש</span>
                  </h1>
                  {/* <div className="w-full xl:w-1/4 md:w-1/4 mr-auto flex flex-col"> */}
                  {/* <div style={{ backgroundColor: '#fde68a' }}
                  className='font-bold mb-3 mt-5 px-2 py-1 rounded self-center text-gray-800 shadow-lg text-center ml-2.5 hidden md:block'>
                  מבצע מטורף 40% הנחה</div> */}
                  {/* <div className="relative flex flex-col h-full px-8 pb-8">
                  <span className='text-sm self-center mt-4 md:mt-0 advanced-sale-details'>במקום ₪{advanced.price}</span>
                  <h1 className="flex items-start mx-auto text-gray-900 tracking-tight">
                    <div className='font-semibold text-xl lg:text-2xl'>
                      <span>{`₪${advancedOnSale.price}`}</span>
                      <span className='text-base text-gray-600 font-normal pr-1'>/ לחודש</span>
                    </div>
                  </h1> */}
                  {/* <span className='text-xs self-center mb-2 text-center'>לנרשמים עד 31/03/2024 למשך שנה</span> */}
                  {/* <Link href='/app/signup'>
                    <a
                      className="px-4 py-2 text-base mt-3 sm:text-lg text-center font-primary font-medium text-white bg-green-500 rounded-full focus:outline-none hover:bg-green-600 w-full">להרשמה</a>
                  </Link> */}
                  <p className="mx-auto text-gray-600 mt-3 text-sm text-center">המחירים אינם כוללים מע״מ</p>
                </div>
              </div>
            </div>

            {/*unlimited*/}
            <PlanDetails plan={unlimited}>
              <>
                <PlanFeaturesSection>
                  <PlanFeature><strong>ללא</strong> הגבלת תורים</PlanFeature>
                  <PlanFeature><strong>ללא</strong> הגבלת לקוחות רשומים</PlanFeature>
                  <div className="flex items-center mb-2 text-lg font-normal text-indigo-800 justify-center md:justify-start">
                    <div className="flex">
                      <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500" />
                      <div className='flex flex-col text-center md:text-right pr-1'>
                        <span className="text-gray-900 text-sm"><strong>{unlimited.smsCredits}</strong> הודעות מתחדשות בחינם </span>
                        <span className='text-xs text-gray-600'>{`(${unlimited.extraSMS} ש״ח לכל הודעה נוספת)`}</span>
                      </div>
                    </div>
                  </div>
                  <PlanFeature><strong>אנשי צוות ללא הגבלה</strong></PlanFeature>
                  <PlanFeature><strong>שיוך שירותים לאנשי צוות</strong></PlanFeature>
                </PlanFeaturesSection>
                <PlanFeaturesSection>
                  <PlanFeature>תזכורות אוטומטיות ואישורי הגעה</PlanFeature>
                  <PlanFeature>סטטיסטיקות ודוחות</PlanFeature>
                  <PlanFeature>שירות לקוחות בצ׳אט</PlanFeature>
                  <PlanFeature>שליחת הודעות תפוצה</PlanFeature>
                  <PlanFeature><strong>מערכת שיעורים למספר משתתפים</strong></PlanFeature>
                </PlanFeaturesSection>
                <PlanPriceSection plan={unlimited} />
              </>
            </PlanDetails>
            <div className="text-gray-500 font-secondary pt-4">
            המנוי החודשי מתחדש אוטומטית מדי חודש בהתאם לתנאי השירות. ניתן לבטל בכל עת דרך האיזור האישי.
            </div>
          </div>
        </div>

        <div>
          <section className="text-gray-700" id='faq'>
            <div className="container px-5 py-16 pt-5 mx-auto">
              <div className="text-center mb-20">
                <h1 className="text-center text-black text-gray-700 font-bold text-4xl sm:text-4xl w-full px-2">שאלות
                  נפוצות</h1>
              </div>
              <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
                <div className="w-full lg:w-1/2 px-4 py-2 cursor-pointer">
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      מהו אופן התשלום עבור המערכת?
                    </summary>

                    <div className='p-2 text-right'>
                      התשלום עבור השירות הינו חודשי בלבד ואין שום התחייבות לטווח הארוך.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      למי מתאימה האפליקציה?
                    </summary>

                    <div className='p-2 text-right'>
                      האפליקציה מתאימה לכל עסק הדורש ניהול יומן עם תורים וניהול לקוחות חכם
                      ויעיל.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      האם אני יכול/ה לבטל את המנוי בכל שלב?
                    </summary>

                    <div className='p-2 text-right'>
                      בוודאי. אין שום התחייבות. במידה ולא תרצו להמשיך את השימוש במערכת, תוכלו להפסיק
                      בכל שלב ע״י יצירת קשר עם שירות הלקוחות.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      אילו הודעות נספרות בחבילה?
                    </summary>

                    <div className='p-2 text-right'>
                      כל הודעה שאנו שולחים אליכם או אל לקוחותיכם בצורה אוטומטית או ידנית, כגון הודעה על ביטול התור, תזכורות אוטומטיות, הודעה על תור חדש שנקבע וכו׳.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      האם האפליקציה מאובטחת?
                    </summary>
                    <div className='p-2 text-right'>כמובן. אנו שמים דגש על אבטחת המידע ופרטיות, ודואגים
                      שכל פרטי הלקוחות שלכם נשמרים בצורה מאובטחת בענן.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      האם צריך להוריד אפליקציה?
                    </summary>
                    <div className='p-2 text-right'>לא :) בכדי להפוך את תהליך קביעת התור לנוח ומהיר עבור לקוחותיכם, הכל מתבצע דרך דף העסק אותו אתם יוצרים. בלי אפליקציות מסובכות!
                    </div>
                  </details>
                </div>
                <div className="w-full lg:w-1/2 px-4 py-2 cursor-pointer">
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      מה זה אומר ״עד 100 תורים החודש״?
                    </summary>

                    <div className='p-2 text-right'>
                      הכוונה היא שהחבילה מוגבלת לעד 100 תורים בחודש. במידה ולקוח קבע תור וביטל, התור עדיין נספר. כל חודש השימוש מתאפס. במידה והגעתם לניצול מלא של החבילה, לקוחות לא יוכלו לקבוע תור.                  </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      מה קורה אם אני חורג/ת מכמות ההודעות החודשית?
                    </summary>
                    <div className='p-2 text-right'>
                      כל חבילה כוללת בתוכה כמות הודעות מסויימת. על כל הודעה נוספת שתישלח מעבר לכמות הכלולה, אנו נחייב אתכם ב-0.08 ש״ח להודעה. לדוגמא, על חריגה של 100 הודעות תשלמו 8 ש״ח נוספים.
                    </div>
                  </details>

                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      איך ניתן לשלם עבור השימוש?
                    </summary>
                    <div className='p-2 text-right'>
                      ניתן לשלם בכרטיס אשראי. החיוב יופיע בתדפיס האשראי שלכם.
                    </div>
                  </details>

                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      כל כמה זמן החבילה שלי מתאפסת?
                    </summary>
                    <div className='p-2 text-right'>
                      החבילה מתאפסת בכל 30 ימים קלנדריים. לדוגמא, במידה והתחלתם לשלם בתאריך 5 לאפריל, החבילה תתאפס שוב ב5 למאי.
                    </div>
                  </details>

                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      האם האפליקציה נגישה דרך הטלפון?
                    </summary>

                    <div className='p-2 text-right'>
                      ברור! התאמנו את האפליקציה לעבוד בצורה הטובה ביותר דרך הטלפון הנייד שלכם, כך שתוכלו
                      לנהל את העסק שלכם מכל מקום ובכל זמן.
                    </div>
                  </details>
                  <details open={true} className="mb-4">
                    <summary className="font-semibold bg-gray-100 rounded-md py-2 px-4">
                      האם יש תמיכה ועזרה ללקוחות?
                    </summary>

                    <div className='p-2 text-right'>
                      בוודאי. אנו נדאג לטפל בכל בעיה או בקשה שעולה לגבי השימוש באפליקציה. לא סתם יש לנו
                      מאות לקוחות מרוצים :)
                    </div>
                  </details>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

Pricing.Layout = WebsiteLayout;
export default Pricing;